import { render } from "./AddressBook.vue?vue&type=template&id=2654a722&scoped=true"
import script from "./AddressBook.vue?vue&type=script&lang=js"
export * from "./AddressBook.vue?vue&type=script&lang=js"

import "./AddressBook.vue?vue&type=style&index=0&id=2654a722&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2654a722"]])

export default __exports__